import { defineMessages } from "react-intl";

const PREFIX = "SubscriptionEdit.Validation";
export default defineMessages({
  nameRequired: {
    id: `${PREFIX}.nameRequired`,
    defaultMessage: "Subscription name is required",
  },
  nameMaxLength: {
    id: `${PREFIX}.nameMaxLength`,
    defaultMessage: "Subscription name might be at most 64 characters long",
  },
  nameCharacters: {
    id: `${PREFIX}.nameCharacters`,
    defaultMessage: "Subscription name includes forbidden characters",
  },
});
